// extracted by mini-css-extract-plugin
var _1 = "SubMenuDefault-modulesubMenuDefault__LGjP5 SubMenuWrapper-moduleSubMenuWrapper__RGQxr";
var _2 = "SubMenuDefault-modulesubTitle__hgD1J";
export { _1 as "subMenuDefault", _2 as "subTitle" }
